<template>
  <a-space direction="vertical ">
    <a-select
      ref="select"
      v-model:value="repairList.requestPayload.repairProcessType"
      style="width: 10rem;"
      allowClear
      @change="handleSearch"
      placeholder="返修进度"
    >
      <a-select-option :value="0">仓管</a-select-option>
      <a-select-option :value="1">质检</a-select-option>
      <a-select-option :value="2">工艺</a-select-option>
      <a-select-option :value="3">生产</a-select-option>
      <a-select-option :value="4">闭环</a-select-option>
      <a-select-option :value="5">审核</a-select-option>
      <a-select-option :value="-1">已完成</a-select-option>
    </a-select>

    <serial-cascader-vue
      @handleSerialChange="handleSerialChange"
    ></serial-cascader-vue>

    <a-input
      v-model:value="repairList.requestPayload.serial"
      placeholder="请输入机身号"
    />

    <a-button style="width: 100%" @click="handleDoSearch">搜索</a-button>
  </a-space>
</template>

<script>
import { defineComponent, ref } from "vue";
import {
  repairList,
  handleUpdatePage,
  handleUpdateRequestPayload,
  getRepairListData,
} from "./serve/search";
import serialCascaderVue from "./components/serialCascader.vue";
import { useRouter } from "vue-router";

export default defineComponent({
  components: { serialCascaderVue },
  setup() {
    const handleSearch = () => {
      handleUpdatePage(1);
    };

    const handleSerialChange = (e) => {
      if (e) repairList.requestPayload.serialType = e;
    };

    const router = useRouter();
    const handleDoSearch = () => {
      getRepairListData();
      router.back();
    };

    return {
      repairList,
      handleSearch,
      handleDoSearch,
      handleSerialChange,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
